/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SpreadsheetContent } from './SpreadsheetContent';
import type { UserProfile } from './UserProfile';
export type SpreadsheetNoteGet = {
  readonly id?: number;
  author: UserProfile;
  updated_by: UserProfile;
  content: SpreadsheetContent;
  readonly created_at?: string;
  readonly updated_at?: string;
  is_deleted?: boolean | null;
  readonly deleted_at?: string | null;
  name?: string | null;
  is_internal?: boolean;
  page_type: SpreadsheetNoteGet.page_type;
  cap_table?: number | null;
  financial_statement?: number | null;
  fund_measurement_date?: number | null;
  fund_ownership?: number | null;
  fund_investment_ownership?: number | null;
  allocation?: number | null;
  valuation_approach?: number | null;
  company_measurement_date?: number | null;
  market_adjustment?: number | null;
  range_sensitivity?: number | null;
  calibration?: number | null;
};
export namespace SpreadsheetNoteGet {
  export enum page_type {
    CT = 'ct',
    FO = 'fo',
    FI = 'fi',
    VA = 'va',
    ALLOC = 'alloc',
    BRKPTS = 'brkpts',
    CS = 'cs',
    FS = 'fs',
    WTRFL = 'wtrfl',
    MA = 'ma',
    FIS = 'fis',
    RS = 'rs',
    CAL = 'cal',
    WB = 'wb',
  }
}

